export default {
  customer_email: { recipient: 'Customer', type: 'Email' },
  customer_sms: { recipient: 'Customer', type: 'SMS' },
  shop_email: { recipient: 'Shop', type: 'Email' },
  sevensenders: { recipient: 'Sevensenders', type: 'Email' },
};
